var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 235.32 229.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_15);}.cls-2{fill:url(#Unbenannter_Verlauf_19);}.cls-3{fill:#e94a47;}.cls-4{fill:url(#Unbenannter_Verlauf_15-2);}.cls-5{fill:url(#Unbenannter_Verlauf_13-2);}.cls-6{fill:#23286b;}.cls-7{fill:url(#Unbenannter_Verlauf_13);}.cls-8{fill:url(#Unbenannter_Verlauf_19-2);}.cls-9{fill:#ffbeb5;}.cls-10{clip-path:url(#clippath);}.cls-11{fill:none;}.cls-12{fill:url(#Unbenannter_Verlauf_16);}.cls-13{fill:#428dfc;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 235.32,
    height: 229.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_16",
    x1: 3332.49,
    y1: -5075.74,
    x2: 3332.49,
    y2: -5047.96,
    gradientTransform: "translate(-5573.14 -28930.8) rotate(22.36) scale(4.88 -4.89) skewX(-.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23286b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151a4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_15",
    x1: 3434.67,
    y1: -4474.35,
    x2: 3440.79,
    y2: -4474.35,
    gradientTransform: "translate(-16640.43 -21833.84) scale(4.88 -4.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbeb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2a19c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_13",
    x1: 3416.43,
    y1: -4479.38,
    x2: 3438.52,
    y2: -4479.38,
    gradientTransform: "translate(-16640.43 -21833.84) scale(4.88 -4.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#81aef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78a9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_19",
    x1: 3445.73,
    y1: -4534.18,
    x2: 3447.64,
    y2: -4533.51,
    gradientTransform: "translate(-16640.43 -22058.65) scale(4.88 -4.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e94a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd2f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_19-2",
    x1: 3451.36,
    y1: -4532.52,
    x2: 3454.94,
    y2: -4536.13,
    xlinkHref: "#Unbenannter_Verlauf_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_15-2",
    x1: 3445.52,
    y1: -4490.93,
    x2: 3432.52,
    y2: -4477.06,
    xlinkHref: "#Unbenannter_Verlauf_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_13-2",
    x1: 3435.49,
    y1: -4489.18,
    x2: 3435.49,
    y2: -4473.64,
    xlinkHref: "#Unbenannter_Verlauf_13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errorscreen"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-i5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L_shoe-i5",
    className: "cls-13",
    d: "m72.42,209.71h17.84s9.39,7.35,19.32,10.89c9.93,3.55,12.96,8.35,12.96,8.35l-58.29.14,8.18-19.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m115,142.34c.21,8.59-2.85,15.87-5.78,23.18-6.18,15.36-13.1,29-18.94,44.21-5.87.11-12.25.27-18.14.55-2.75-6.61-4.14-10.94-3.45-18.57.38-4.31,2.48-10.96,3.89-15.68,1.86-6.77,4.22-13.39,7.07-19.8,1.41-3.03,4.32-4.69,4.79-8.66,1.2-10.26-3.78-20.46-8.08-29.69-4.63-9.93-6.18-18.57-7.22-28.86-.51-3.55-.1-7.16,1.17-10.51,1.39-3.64,3.53-7.07,7.82-8.26,7.44-2.08,13.65.19,18.79,5.42,3.53,3.66,4.23,8.22,5.98,12.81,6.56,17.2,11.63,35.67,12.1,53.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L_shoe-2-i5",
    className: "cls-13",
    d: "m20.45,177.56c3.65,4.76,7.26,9.4,10.89,14.25-.1,7.34.71,14.66,2.43,21.79,1.47,6.11,2.45,10.08.98,15.78-11.56-15.83-23.16-31.42-34.75-47.17,6.81-1.58,13.63-3.1,20.45-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m74.07,58.49c-16.89,10.18-14.38,13.16-14.24,27.96.08,8.23,2.94,15.91,4.19,22.99,1.25,7.07,4.65,16.48-2.85,20.86-14.31,8.33-12.04,14.69-21.43,24.82-8.51,9.18-17.35,10.07-20.45,22.78,3.89,4.64,8.08,9.36,12.04,14.09,21.29-12.08,40.11-28.43,58.15-44.62,3.34-3,5.74-5.3,7.54-8.89,3.43-6.83,2.91-13.19,3-20.53.14-10.26-1.06-18.98.21-29.79.71-6.07-1.53-17.41-4.17-22.62-3.48-6.86-19.02-8.84-22-7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149,23.05c-6.91.04-13.81-.55-20.61-1.77-1.61,7.21,1.13,17.62,4.48,23.29,8.83-4.12,24.93-10.61,24.93-10.61l-1.18-11.86s-5.71.88-7.61.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m192.41,23.87c-.6,2.2-1.61,4.28-2.97,6.11-.88,1.26-1.93,2.6-2.74,3.87-1.54,2.43-2.19,3.44-3.53,5.92-.4.73-.94,2.65-1.48,3.31-.59.64-1.44.97-2.31.88-1.36-.46-2.56-1.31-3.44-2.44-2.16.76-4.46,1-6.73.68-3-.42-4.58-1.35-7.01-3.26-5.3-4.19-6.84-13.08-4.74-19.34,2.28-6.56,7.46-11.7,14.04-13.91,3.72-1.22,7.74-1.15,11.4.22,4.47,1.82,7.85,5.6,9.17,10.25.88,3.15.98,5.23.34,7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m140.83,29.54c.6,3.4,2.38,7.63,5.89,9.03-3.77,11.22-11.73,17.6-20.13,25.51-9.6,9.04-18.41,18.65-20.49,32.14-9.42-1.77-18.09-2.15-27.38-5.43-9.29-3.28-15.9-6.5-23.46-14.91-3.99-4.48-11.03-14.87-16.4-19.65,6.01-9.19,12.28-15.85,23.85-17.84,5.4-.88,14.78-8.84,18.21-10.8,20.53-11.76,51.56-9.89,59.77-4.78-.11,2.62-.4,3.78.13,6.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magnifying_glass-i5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "handle-i5",
    className: "cls-2",
    d: "m192.26,100.41h-5.85c-4.7-.07-5.48-.67-5.55-2.27v-.28s0-.06,0-.09h0c.42-.88,2.39-1.18,3.75-1.24h6.18c.11,1.41.61,2.75,1.46,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle-i5",
    className: "cls-8",
    d: "m213.09,108.03c-12.47,0-22.24-5.21-22.24-11.86s9.77-11.86,22.24-11.86,22.23,5.21,22.23,11.86-9.77,11.86-22.23,11.86Zm0-20.24c-8.88,0-18.77,3.44-18.77,8.38s9.89,8.38,18.77,8.38,18.76-3.44,18.76-8.38-9.89-8.38-18.76-8.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.06,100.38c-7.95.18-9.12-.3-9.19-2.25-.07-1.95,5.18-1.65,5.18-1.65,0,0-.13-.58-2.71-1.15-2.58-.57-7.95,1.68-13.8.57-3.87-.75-7.64-4.01-10.73-6.27-4.19-2.97-8-6.43-11.38-10.3-7.01-8.25-12.9-17.85-14.71-28.66-.64-3.82-.81-7.86-2.75-11.21-.14-.3-.38-.55-.67-.71-.31-.1-.65-.1-.96,0-4.65,1.34-8.46,4.69-10.4,9.13-1.89,4.43-2.36,9.34-1.37,14.06,1,4.68,2.77,9.16,5.23,13.26,15.3,20.03,28.7,22.01,35.15,23.87,5.25,1.49,6.96.22,11,6.84s13.67,5.39,13.67,5.39c4.18-.26,15.42-11.08,8.43-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m145.73,46.7c-1.16,7.23-2.31,14.71-.55,21.83,1.64,6.6,5.7,12.38,10.35,17.34-5.39,6.18-10.35,12.72-14.86,19.57-11.34-3.87-16.21-16.8-16.78-17.68-1.9-3-4.29-5.66-7.07-7.88-5.15-3.69-7.56-12.49-8.33-18.78-.63-5.16.44-9.97,1.95-14.94,1.51-4.97,5.71-8.97,10.28-11.43,3.03-1.64,16.68-4.9,20.11-5.23.57,3.21,2.18,7.79,5.89,9.03.16.16-.45,4.8-1.01,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m192.54,17.79c.48,3.85.21,7.75-.79,11.49-3.24-1.17-5.51-2.65-7.2-5.66-1.69-3.01-.45-8.26.23-11.64.66-3.23.36-5.57,3.47-2.76,2.33,2.3,3.84,5.32,4.28,8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m184.18,18.24l-.18.1c-9.67,5.51-16.62,14.8-19.18,25.64-.71,2.98-1.17,6.01-1.38,9.07-1.08-.88-3.35-2.65-4.96-3.88-1.11-.88-1.69-2.27-1.52-3.68.84-6.62,3.26-12.95,7.07-18.43-4.71,5.44-9.34,10.84-11.61,17.51-4.26-7.21-8.26-22.54-8.15-27.34,0,0,5.88-5.5,10.21-9.47,4.33-3.97,13.72-8.77,21.89-7.57,4.35.48,8.34,2.63,11.14,6,1.83,2.18,3.35,4.62,4.63,9.64-2.06-1.26-6.2,4.03-7.94,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.91,53.5c-.23,0-.42-.17-.44-.4-.88-9,1.93-18.78,7.95-27.55.14-.2.4-.25.6-.11,0,0,0,0,0,0,.2.13.25.4.12.6,0,0,0,0,0,0-5.91,8.59-8.68,18.15-7.79,26.99.02.24-.16.46-.4.49l-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m143.7,14.77c-.14,0-.27-.06-.35-.17-.15-.2-.11-.48.09-.63l1.2-.88c4.92-3.78,12.36-9.5,21.54-11.81.24-.06.47.09.53.33.06.23-.07.46-.29.52,0,0-.02,0-.03,0-9.01,2.26-16.36,7.96-21.2,11.65l-1.21.88c-.08.06-.18.1-.28.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e9d45c6b5d8a91075092201134816c7f.svg";
export { ForwardRef as ReactComponent };